import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

export default function SectionHeader({
  eyebrow,
  title,
  description,
  align = 'center',
  as = 'h2',
  ...props
}) {
  const isCentered = align === 'center';
  return (
    <Box
      textAlign={align}
      maxW={isCentered ? '720px' : 'none'}
      mx={isCentered ? 'auto' : 0}
      mb={{ base: 8, md: 12 }}
      {...props}
    >
      {eyebrow && (
        <Text
          fontSize="xs"
          fontWeight={700}
          letterSpacing="0.08em"
          textTransform="uppercase"
          color="accent.default"
          mb={2}
        >
          {eyebrow}
        </Text>
      )}
      <Heading as={as} size="h2">
        {title}
      </Heading>
      {description && (
        <Text mt={4} color="text.secondary">
          {description}
        </Text>
      )}
    </Box>
  );
}
